import { useEffect, useState } from 'react'

import { api, type App } from '../api'

export function Apps({ onOpen }: { onOpen: (id: string) => void }) {
  const [apps, setApps] = useState<App[]>([])
  const [name, setName] = useState('')
  const [appId, setAppId] = useState('')
  const [freshKey, setFreshKey] = useState('')
  const [error, setError] = useState('')

  async function reload() {
    try {
      const { apps } = await api.apps()
      setApps(apps ?? [])
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Не удалось загрузить приложения')
    }
  }

  useEffect(() => {
    void reload()
  }, [])

  async function create(event: React.FormEvent) {
    event.preventDefault()
    if (!name.trim()) return
    try {
      const { api_key } = await api.createApp(name.trim(), appId.trim() || undefined)
      setFreshKey(api_key)
      setName('')
      setAppId('')
      await reload()
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Не удалось создать приложение')
    }
  }

  return (
    <div className="stack">
      <div>
        <h1>Приложения</h1>
        <p className="muted">
          App ID из карточки приложения — это тот же идентификатор, который ожидает SDK OneSignal.
        </p>
      </div>

      {error && <div className="notice error">{error}</div>}

      {freshKey && (
        <div className="notice secret">
          <strong>App API key создан.</strong> Он показывается один раз — сохраните его сейчас:
          <br />
          <code>{freshKey}</code>
        </div>
      )}

      <form className="card stack" onSubmit={create}>
        <div className="row">
          <input
            placeholder="Название приложения"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ flex: 1, minWidth: 220 }}
          />
          <button className="primary" type="submit">
            Создать приложение
          </button>
        </div>
        <label>
          Свой App ID — необязательно
          <input
            placeholder="например, если переезжаете и идентификатор уже зашит в клиентах"
            value={appId}
            onChange={(e) => setAppId(e.target.value)}
          />
        </label>
      </form>

      <div className="card table-wrap">
        <table>
          <thead>
            <tr>
              <th>Название</th>
              <th>App ID</th>
              <th>Создано</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {apps.map((app) => (
              <tr key={app.id}>
                <td>{app.name}</td>
                <td className="mono">{app.id}</td>
                <td className="muted">{new Date(app.created_at).toLocaleDateString()}</td>
                <td>
                  <button className="link" onClick={() => onOpen(app.id)}>
                    Открыть
                  </button>
                </td>
              </tr>
            ))}
            {apps.length === 0 && (
              <tr>
                <td colSpan={4} className="muted">
                  Пока нет ни одного приложения.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
